export default __webpack_public_path__ + "static/media/toilet.inline.01641254.svg";